
import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormAdminInit} from "./adminModel";


// import {INIT} from './../constants/status';

const initialState = {
    admins: [],
    adminForm: FormAdminInit,
};

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setAdmins: (state, action) => {
            state.admins = action.payload;
        },
        onAdminFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.adminForm[name] = value;
        },
        initAdminForm: (state, action) => {
            state.adminForm = action.payload;
        },
    },
});

export const {actions} = adminSlice;
export const {
    setAdmins,
    onAdminFormChange,
    initAdminForm,
} = actions;

// selectors

export const selAdmins = (state) => state.admin.admins;
export const selAdminForm = (state) => state.admin.adminForm;

const reducer = {
    admin: adminSlice.reducer,
};
export default reducer;